import { NgModule } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ModalComponent } from './modal.component';
import { TypographyComponentModule } from '../typography/typography.module';
import { ButtonComponentModule } from '../button/button-component.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [ModalComponent],
  imports: [
    CommonModule,
    DialogModule,
    TypographyComponentModule,
    ButtonComponentModule,
  ],
  exports: [ModalComponent],
})
export class ModalComponentModule {}
